var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseDataList',{ref:"dataList",attrs:{"items":_vm.linkedContacts,"service":_vm.fethcLinkedContacts},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('LinkedContactListHeader')]},proxy:true},{key:"default",fn:function({ item }){return [_c('LinkedContactListItem',{attrs:{"contact":item}})]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }